var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',{attrs:{"id":"scroll-list"}},[_vm._l((_vm.renderedItems),function(item,index){return _c('fragment',{key:JSON.stringify(item),attrs:{"id":"loop-for-items"}},[_vm._t("list-item",null,{"item":item,"index":index})],2)}),(_vm.morePages)?_c('scroll-trigger',{on:{"triggerVisible":_vm.readPage}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }